
const alignConstants = {
    ALIGN_LEFT: 'left',
    ALIGN_RIGHT: 'right',
    ALIGN_CENTER: 'center'
};

const sizeConstants = {
    SIZE_SMALL: 'small',
    SIZE_MEDIUM: 'medium',
    SIZE_LARGE: 'large',
    SIZE_EXTRA_LARGE: 'extraLarge'
};

export {
    alignConstants,
    sizeConstants
};



// WEBPACK FOOTER //
// ./src/components/Dropdown/dropdownConstants.js